const tbTas = {
  table: 'tb_tas',
  idKey: 'id',

  attrs: [
    'creationDate',
    'lastModifiedDate',
    'deleted'
  ],

  relationships: [  
    {
      type: 'companies',
      key: 'company',
    },  
    {
      type: 'toolboxes',
      key: 'toolbox',
    },
    {
      type: 'tas',
      key: 'ta',
    }
  ],
}

export default  tbTas